import { LivestockSpecies, RDGrazing } from '@cibo/core'
import { pathEq } from 'ramda'
import { date, number, object, string } from 'yup'
import { eventValidationSchema } from '../EventDetail'
import { ITraitFeatureByIdYear } from '../types'
import { findInitialValuesDetail } from '../utils'
import { GrazingCellDisplay } from './GrazingCellDisplay'
import { GrazingEditor } from './GrazingEditor'
import { GrazingRollup } from './GrazingRollup'
import { GrazingSimpleCell } from './GrazingSimpleCell'

const TRAIT_ID = 'grazing'

export const Grazing: ITraitFeatureByIdYear<RDGrazing> = {
  traitId: TRAIT_ID,
  cellDisplay: GrazingCellDisplay,
  SimpleCellView: GrazingSimpleCell,
  editor: GrazingEditor,
  forbidBulkEdit: false,
  initialValues: request => {
    const detail = findInitialValuesDetail(TRAIT_ID)(request)
    return detail?.input || {}
  },
  rollups: {
    default: {
      traitId: TRAIT_ID,
      Component: GrazingRollup,
      detailBaseValue: () => ({
        traitId: TRAIT_ID,
        input: {},
      }),
      isRollupValue: pathEq(['result'], false),
    },
  },
  ns: '@cibo/landmanager/GrazingEditor',
  //@ts-ignore For some reason it's yelling about RDGrazing['input'] not being assignable to undefined, but it also doesn't like that
  validationSchema: eventValidationSchema<RDGrazing['input']>(({ t }) =>
    object().shape({
      startDate: date().nullable().optional(),
      species: string<LivestockSpecies>()
        .required(t('errorRequired', { context: 'species' }))
        .typeError(t('errorRequired', { context: 'species' })),
      headCount: number()
        .integer()
        .min(1, t('errorMin', { context: 'headCount' }))
        .required(t('errorRequired', { context: 'headCount' }))
        .typeError(t('errorRequired', { context: 'headCount' })),
      daysGrazing: number()
        .integer()
        .min(1, t('errorMin', { context: 'daysGrazing' }))
        .max(365, t('errorMax', { context: 'daysGrazing' }))
        .required(t('errorRequired', { context: 'daysGrazing' }))
        .typeError(t('errorRequired', { context: 'daysGrazing' })),
    })
  ),
}
